module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fyA1Z"))).then(() => parcelRequire('3a9aZ'));